export default "__VITE_ASSET__BLVGqxoM__"